// src/components/ConsentOptions.js
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import {
  doc,
  setDoc,
  getDoc,
  collection,
  addDoc,
  query,
  orderBy,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";

const CONSENT_LABELS = {
  bloodPressure: "Blood Pressure",
  glucose: "Glucose",
  hba1c: "HbA1c",
  reminders: "Reminders & Notifications",
  aiInsights: "AI-driven Insights & Analytics",
};

export default function ConsentOptions() {
  const [consents, setConsents] = useState({});
  const [history, setHistory] = useState([]);
  const [consentStatus, setConsentStatus] = useState(null);

  const user = auth.currentUser;

  useEffect(() => {
    if (!user) return;

    // load current consent
    const consentDocRef = doc(db, "users", user.uid, "consent", "current");
    getDoc(consentDocRef).then((snap) => {
      if (snap.exists()) {
        setConsents(snap.data());
        setConsentStatus(snap.data());
      }
    });

    // load history
    const q = query(
      collection(db, "users", user.uid, "consentHistory"),
      orderBy("timestamp", "desc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const hist = snapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));
      setHistory(hist);
    });

    return () => unsubscribe();
  }, [user]);

  const handleConsentChange = async (key) => {
    const updated = { ...consents, [key]: !consents[key] };
    setConsents(updated);

    const consentDocRef = doc(db, "users", user.uid, "consent", "current");
    await setDoc(consentDocRef, {
      ...updated,
      lastUpdated: new Date().toISOString(),
    });

    // log history
    await addDoc(collection(db, "users", user.uid, "consentHistory"), {
      action: `${CONSENT_LABELS[key]} ${updated[key] ? "enabled" : "disabled"}`,
      details: updated,
      timestamp: serverTimestamp(),
    });
  };

  const renewConsent = async () => {
    if (!user) return;

    await addDoc(collection(db, "users", user.uid, "consentHistory"), {
      action: "Renewed Consent",
      details: consents,
      timestamp: serverTimestamp(),
    });
  };

  return (
    <div className="section-card">
      <h2>Privacy & Consent</h2>

      <h3>Granular Consent Options</h3>
      {Object.keys(CONSENT_LABELS).map((key) => (
        <div key={key}>
          <label>
            <input
              type="checkbox"
              checked={!!consents[key]}
              onChange={() => handleConsentChange(key)}
            />
            {` Share & track ${CONSENT_LABELS[key]} data`}
          </label>
        </div>
      ))}

      <h3>Consent History</h3>
{history.length === 0 ? (
  <p>No consent changes yet.</p>
) : (
  <div className="consent-history">
    {history.map((h) => {
      const action = h.action?.toLowerCase() || "";
      let icon = "ℹ️";
      let color = "#333";

      if (action.includes("enabled") || action.includes("renewed")) {
        icon = "✅";
        color = "green";
      } else if (action.includes("disabled")) {
        icon = "❌";
        color = "red";
      }

      return (
        <div
          key={h.id}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px 12px",
            marginBottom: "6px",
            border: "1px solid #ddd",
            borderRadius: "6px",
            backgroundColor: "#fafafa",
          }}
        >
          <span style={{ fontSize: "0.9rem", color: "#666" }}>
            📅 {h.timestamp?.toDate().toLocaleString()}
          </span>
          <span style={{ fontWeight: "bold", color }}>
            {icon} {h.action}
          </span>
        </div>
      );
    })}
  </div>
)}

    </div>
  );
}
